

















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import axios from 'axios';
import * as d3 from 'd3';
import {SimulationNodeDatum} from 'd3-force';
import {namespace} from 'vuex-class';
import {SearchState} from '@/store/search/types';

import SearchField from '@/components/SearchField.vue';
import {AdminusStore} from '@/store/types';

const searchState = namespace('search');
const backendData = namespace('deployData');

@Component({
    components: {
        SearchField,
    },
})

export default class Network extends Vue {
    @Prop()
    private jsonData: any;


    @Watch('jsonData')
    private onPropertyChanged(value: string, oldValue: string) {
        const ddd = JSON.parse(JSON.stringify(value));
        this.drawGraph(ddd.data);
    }

    private cleanCanvas(entireGraph: HTMLElement) {
        let child = entireGraph.lastElementChild;
        while (child) {
            entireGraph.removeChild(child);
            child = entireGraph.lastElementChild;
        }
    }

    private drawGraph(data: any) {
        // set the dimensions and margins of the graph
        const margin = {top: 10, right: 20, bottom: 30, left: -80};
        const width = 1250 - margin.left - margin.right;
        const height = 760 - margin.top - margin.bottom;

        // append the svg object to the body of the page
        const entireGraph = document.getElementById('network');
        if (entireGraph) {
            this.cleanCanvas(entireGraph);
        }
        const svg = d3.select(entireGraph)

            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        // build the arrow.
        svg.append('svg:defs').selectAll('marker')
            .data(['end'])
            .enter().append('svg:marker')
            .attr('id', (d) => {
                return d;
            })
            .attr('viewBox', '0 -5 10 10')
            .attr('refX', 30)
            .attr('refY', -1)
            .attr('markerWidth', 6)
            .attr('markerHeight', 6)
            .attr('orient', 'auto')
            .append('path')
            .attr('d', 'M0,-5L10,0L0,5');

        // Initialize the links
        const link = svg
            .append('g')
            .attr('class', 'links')
            .selectAll('line')
            .data(data.links)
            .enter()
            .append('line')

            .attr('stroke-width', () => {
                return 1;
            })
            .attr('marker-end', 'url(#end)');

        link.style('fill', 'none')
            .style('stroke', '#ccc')
            .style('stroke-width', '2px');

        const node = svg
            .selectAll('.node')
            .data(data.nodes)
            .enter()
            .append('g')
            .attr('class', 'node');
        // .call(d3.drag().on('start', (d: SimulationNodeDatum) => {
        //     if (!d3.event.active) {
        //         simulation.alphaTarget(0.3).restart();
        //     }
        //     d.fx = d.x;
        //     d.fy = d.y;
        // }).on('drag', (d: SimulationNodeDatum) => {
        //     d.fx = d3.event.x;
        //     d.fy = d3.event.y;
        // }).on('end', (d: SimulationNodeDatum) => {
        //     if (!d3.event.active) {
        //         simulation.alphaTarget(0);
        //     }
        //     d.fx = null;
        //     d.fy = null;
        // }));

        node.each(function(d: any) {

            if (d.group === 'application') {
                d3.select(this).append('circle')
                    .attr('r', 12)
                    .style('fill', '#4EACFB');
            } else {
                d3.select(this).append('rect')
                    .attr('height', 80)
                    .attr('width', 150)
                    .attr('x', -(15))
                    .style('fill', '#ffffff')
                    .attr('stroke', '#2378ae')
                    .attr('stroke-dasharray', '10,5')
                    .attr('stroke-linecap', 'butt')
                    .attr('stroke-width', '3')
                    .attr('border-radius', '15px');
            }

            d3.select(this).append('image')
                .attr('xlink:href', (dd: any) => {
                    const imgpath = '/static/';
                    const res = imgpath + dd.type + '.svg';
                    return res;
                })
                .attr('x', () => {
                    return 6;
                })
                .attr('y', () => {
                    return 5;
                });

        });

        node.on('click', (d: any) => {
            d3.select('h1').html('Type is : ' + d.type);
            d3.select('h3').html(d.name);
        });

        const label = svg.selectAll(null)
            .data(data.nodes)
            .enter()
            .append('svg:text')
            .text((d: any) => {
                if (d.group === 'application') {
                    return d.name;
                }
            })
            .style('text-anchor', 'middle')
            .style('fill', '#555')
            .style('font-family', 'Arial')
            .style('font-size', 12);


        node.append('title')
            .text((d: any) => 'Type is - ' + d.type);


        // Let's list the force we wanna apply on the network
        const simulation = d3.forceSimulation(data.nodes)
        // This adds repulsion between nodes. Play with the -400 for the repulsion strength
            .force('charge', d3.forceManyBody().strength(-100))
            // This force attracts nodes to the center of the svg area
            .force('center', d3.forceCenter(width / 2, height / 2))
            .on('tick', ticked);

        simulation.force('link', d3.forceLink()
            .id((d: any) => {
                return d.id;
            }).links(data.links).distance(250));

        // This function is run at each iteration of the force algorithm, updating the nodes position.


        function ticked() {
            link.attr('d', (d: any) => {
                const dx = d.target.x - d.source.x;
                const dy = d.target.y - d.source.y;
                const dr = Math.sqrt(dx * dx + dy * dy);
                return 'M' +
                    d.source.x + ',' +
                    d.source.y + 'A' +
                    dr + ',' + dr + ' 0 0,1 ' +
                    d.target.x + ',' +
                    d.target.y;
            });

            node.attr('transform', (d: any) => {
                return 'translate(' + d.x + ',' + d.y + ')';
            });

            label.attr('x', (d: any) => {
                return d.x;
            })
                .attr('y', (d: any) => {
                    return d.y - 10;
                });

        }

        simulation
            .nodes(data.nodes)
            .on('tick', ticked);

        simulation.force<any>('link')
            .links(data.links);
    }
}


